import { Injectable, inject } from '@angular/core';
import { FloorAcl, FloorAclGroups, FloorAclMembers, SecurityService } from '@era/locations-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import {
  AccessControlListApiActions,
  FloorAclPermissionsUiActions,
  FloorPermissionsResolverActions,
} from './floor-acl.actions';

@Injectable()
export class FloorAclEffects {
  private readonly securityService = inject(SecurityService);
  private readonly actions$ = inject(Actions);

  groupLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FloorPermissionsResolverActions.floorAclRequested),
      mergeMap(({ resourceId, locationResourceId }) =>
        safeMap(
          this.securityService.getFloorAcls({ resourceId, locationResourceId }),
          (floorAcl: FloorAcl) => AccessControlListApiActions.floorAclLoaded({ floorAcl }),
          (error) => AccessControlListApiActions.floorAclLoadedError({ error })
        )
      )
    );
  });

  floorAclMemberPutEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FloorAclPermissionsUiActions.floorAclMemberPut),
      mergeMap(({ aclMember }) =>
        this.securityService
          .putFloorAclMembers({ resourceId: aclMember.resourceId, floorAclMembers: aclMember })
          .pipe(
            map((floorAclMember: FloorAclMembers) =>
              AccessControlListApiActions.floorAclMemberPut({ aclMember: floorAclMember })
            )
          )
      )
    );
  });

  floorAclGroupPutEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FloorAclPermissionsUiActions.floorAclGroupPut),
      mergeMap(({ aclGroup }) =>
        this.securityService
          .putFloorAclGroups({ resourceId: aclGroup.resourceId, floorAclGroups: aclGroup })
          .pipe(
            map((floorAclGroup: FloorAclGroups) =>
              AccessControlListApiActions.floorAclGroupPut({ aclGroup: floorAclGroup })
            )
          )
      )
    );
  });

  floorAclGroupDeleteEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FloorAclPermissionsUiActions.floorAclGroupRemove),
      mergeMap(({ aclGroup }) =>
        this.securityService
          .deleteFloorAclGroups({ resourceId: aclGroup.resourceId, floorAclGroups: aclGroup })
          .pipe(map(() => AccessControlListApiActions.floorAclGroupRemove({ aclGroup })))
      )
    );
  });
}
